export default "__VITE_ASSET__C6xW$9DJ__"